import React, { Component } from "react";
import ToTop from "react-scroll-top";
import styled from "styled-components";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";

import TextStyles from "./universal-styles/TextStyles";
import TrailerStyles from "./universal-styles/TrailerStyles";

export default class PageNotFound extends Component {
  render() {
    return (
      <PageWrapper id="top">
        <ImageWrapper>
          <img
            src="https://cosmic-s3.imgix.net/10cefb20-d7b6-11e8-86ad-01c78a4d864e-NotFound.jpg"
            alt="404 - Page Not Found"
          />
        </ImageWrapper>
        <HeadingWrapper>
          <h1>404 - Page Not Found</h1>
        </HeadingWrapper>
        <TextStyles>
          <p>
            Uh-oh, it looks like you took a wrong turn and are now completely
            surrounded by Zeds! Please reload your MKB and try to get yourself
            out of this sticky situation. Hint: you can always click on one of
            the links at the top of the page, or{" "}
            <Link to="/">run home here</Link>. If you think that you arrived
            here by mistake, please contact us and we will quickly remedy the
            situation... but we can't promise that you won't escape completely
            unscathed!
          </p>
          <p>
            If you're still reading this then maybe you should find something
            better to do with your life, like{" "}
            <Link to="/games">play one of our games</Link>.
          </p>
          <p>
            Still here? Okay, I'll give you something to do. How about watch the
            following video and get a life:
          </p>
        </TextStyles>
        <TrailerStyles>
          <div className="player-wrapper">
            <ReactPlayer
              className="react-player"
              url="https://www.youtube.com/watch?v=Yg616SBA8eM&t=42s"
              width="100%"
              height="100%"
            />
          </div>
        </TrailerStyles>
        <ToTop hideAt={160} position="top" />
      </PageWrapper>
    );
  }
}

const PageWrapper = styled.div`
  margin: auto;
  padding-bottom: 60px;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: solid;
  border-width: 2px 0;
  border-color: #fde704;

  img {
    height: 100%;
    width: 100%;
  }
`;

const HeadingWrapper = styled.div`
  color: #fde704;
  text-align: center;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
`;



// WEBPACK FOOTER //
// ./src/components/PageNotFound.js